// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__CSzUy","menu_list":"UserMenu_menu_list__tAu49","menu_item":"UserMenu_menu_item__j9980","menu_item_link":"UserMenu_menu_item_link__gN8ve"};